<template>
  <div class="notice">
    <div class="content">
      <div class="content-notice-title">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" class="demo-form-inline">
          <el-form-item label="通知状态">
            <el-select v-model="searchForm.status" clearable placeholder="请选择">
              <el-option v-for="item in statuss" :key="item.dictId" :label="item.dictName"
                :value="item.dictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知类型">
            <el-select v-model="searchForm.type" clearable placeholder="请选择">
              <el-option v-for="item in positionList" :key="item.Id" :label="item.dictName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知标题">
            <el-input v-model="searchForm.message" @input="handleSearchInput" clearable placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="接收时间">
            <el-date-picker v-model="receiveTime" type="daterange" class="my-date-picker" range-separator="-"
              start-placeholder="年/月/日" end-placeholder="年/月/日" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy/MM/dd"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button plain type="primary" @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="notice-line"></div>
      <div class="content-notice-list">
        <div class="notice-list-title">
          <div class="notice-list-title-left">
            <h4>数据列表</h4>
            （共{{ readCount.total }}条信息，其中已读{{ readCount.readConfirm }}条，未读<p>{{ readCount.unread }}</p>条）
          </div>
          <div class="notice-list-title-right" @click="handleAllRead">
            <img src="../../assets/img/notice/icon_yidu_16.png" alt="">
            <p>全部标记已读</p>
          </div>
        </div>
        <lb-table :column="columns" :data="list" pagination :total="totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.pageNo" :page-size="page.pageSize" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>

<script>
import LbTable from '@/components/lb-table/lb-table'
import eldate from '@/components/eldate.vue'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  name: "notice",
  components: {  LbTable, eldate },
  data() {
    return {
      message: "notice",
      statuss: [
        { dictId: '0', dictName: '全部' },
        { dictId: '2', dictName: '已读' },
        { dictId: '1', dictName: '未读' }
      ],
      positionList: [
        { Id: '0', dictName: '全部' },
        { Id: '1', dictName: '审批单' },
        { Id: '2', dictName: '公告' },
        { Id: '3', dictName: '资产管理' },
        { Id: '4', dictName: '考勤' },
        { Id: '5', dictName: '系统提示' }
      ],
      // readCount: {},
      formInline: {
        user: '',
        region: ''
      },
      receiveTime: [],
      searchForm: {
        id: '', //消息id
        message: '', //消息标题
        type: null, //消息类型 1 审批单 2 公告 3 资产管理 4 考勤 5 系统提示
        receiveTime: '', //接收时间
        startTime: '', //开始时间
        endTime: '', //结束时间
        readStatus: '', //消息状态 1 未读 2 已读
        status: '', //消息状态 1 全部 2 已读 3 未读
        pageNo: 1,
        pageSize: 10,
        allFlag: 0,
        ids: []
      },
      list: [],
      totalNum: 0,
      page: {
        pageNo: 1,
        pageSize: 10
      },
      url: '',
      urlArr: [],
      columns: [
        {
          label: '序号', prop: 'id', width: '80',
          render: (h, scope) => h('div', {
            style: { color: '#2F3030', fontWeight: '400', fontSize: '14px' }
          }, scope.$index + 1 + (this.page.pageNo - 1) * this.page.pageSize < 10 ? '0' + (scope.$index + 1 + (this.page.pageNo - 1) * this.page.pageSize) : (scope.$index + 1 + (this.page.pageNo - 1) * this.page.pageSize)),
        },
        {
          label: '通知标题',
          prop: 'message',
          minwidth: '700',
          renderHeader: (h, { column }) => {
            return h('div', { style: { textAlign: 'left' } }, column.label);
          },
          render: (h, scope) => {
            let vv = ''
            if (scope.row.readStatus == '2') {
              vv = <p style="font-size:14px;display:flex;justify-content:left;color: #939696;">
                <img src="https://fenxiao.muruji.com/internalSystem/4dd4050e-aea5-4891-a59c-8aa1da2cca72" alt="" style="max-width:16px; height:16px; margin-top:3px; margin-right:8px;" />
                <div>{scope.row.message}</div>
              </p>
            } else {
              vv = <p style="font-size:14px;display:flex;justify-content:left;color: #2F3030;">
                <img src="https://fenxiao.muruji.com/internalSystem/fbf1371e-00a6-4c15-83fe-24dea4f5bd3a" alt="" style="max-width:16px; height:16px; margin-top:3px; margin-right:8px;" />
                <div>{scope.row.message}</div>
              </p>
            }
            return (
              <div
                style="cursor: pointer;"
                onClick={() => this.handleTitleClick(scope.row)}
              >
                {vv}
              </div>
            )
          }
        },
        {
          label: '接收时间', prop: 'receiveTime', width: '159',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.readStatus == '2') {
              vv = <div style="color: #939696;">{scope.row.receiveTime}</div>
            } else if (scope.row.readStatus == '1') {
              vv = <div style="color: #2F3030;">{scope.row.receiveTime}</div>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        {
          label: '通知类型', prop: 'type', width: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.readStatus == '2') {
              if (scope.row.type == 1) {
                vv = <div style="color: #939696;">审批单</div>
              } else if (scope.row.type == 2) {
                vv = <div style="color: #939696;">公告</div>
              } else if (scope.row.type == 3) {
                vv = <div style="color: #939696;">资产管理</div>
              }
              else if (scope.row.type == 4) {
                vv = <div style="color: #939696;">考勤</div>
              }
              else if (scope.row.type == 5) {
                vv = <div style="color: #939696;">系统提示</div>
              }
            } else if (scope.row.readStatus == '1') {
              if (scope.row.type == 1) {
                vv = <div style="color: #2F3030;">审批单</div>
              } else if (scope.row.type == 2) {
                vv = <div style="color: #2F3030;">公告</div>
              } else if (scope.row.type == 3) {
                vv = <div style="color: #2F3030;">资产管理</div>
              }
              else if (scope.row.type == 4) {
                vv = <div style="color: #2F3030;">考勤</div>
              }
              else if (scope.row.type == 5) {
                vv = <div style="color: #2F3030;">系统提示</div>
              }
            }

            return (
              <div> {vv}</div>
            )
          }
        },
        {
          label: '已读/未读', prop: 'readStatus', width: '120',
          render: (h, scope) => {
            let vv = ''
            let color = ''
            if (scope.row.readStatus == '1') {
              vv = <p style="font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #E23C58;;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                <div>未读</div>
              </p>
            } else if (scope.row.readStatus == '2') {
              vv = <p style="font-size:14px;display:flex;justify-content:center;color: #939696;"><div style="width: 8px;height: 8px;background: #00B498;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                <div>已读</div>
              </p>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        {
          label: '操作', prop: 'sexLabel', width: '80',fixed: 'right',
          render: (h, scope) => {
            return (
              <div style="display:flex;justify-content:center" onClick={() => this.handleTitleClick(scope.row)}>
                <div style="color:#00B498;cursor:pointer;margin-right:8px" >查看</div>
              </div >
            )
          }
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['readCount']), //自动响应式更新
  },
  mounted() { },
  created() {
    this.getList()
  },
  activated() {
    // this.getreadCount()
    this.fetchData()
  },
  methods: {
    //处理输入框内容变化、加上防抖
    handleSearchInput: _.debounce(function (value) {
      //限制输入长度不超过64个字符
      if (value.length > 64) {
        this.$message.warning('输入长度不能超过64个字符');
        this.searchForm.message = '';//清空输入框内容
      }
    }, 300),
    handleTitleClick(row) {
      console.log('handleTitleClick', row);
      const detailPathMap = {
        '1': row.processInstanceId ? '/' + row.url  + row.processInstanceId : '/' + row.url,
        '2': row.processInstanceId ? '/' + row.url  + row.processInstanceId : '/' + row.url,
        '3': row.processInstanceId ? '/' + row.url  + row.processInstanceId : '/' + row.url,
        '4': row.processInstanceId ? '/' + row.url  + row.processInstanceId : '/' + row.url,
        '5': row.detailId ? '/' + row.url + row.detailId : '/' + row.url,
        '6': row.detailId ? '/' + row.url + row.detailId : '/' + row.url,
        '7': row.detailId ? '/' + row.url + row.detailId : '/' + row.url, 
        '8': row.detailId ? '/' + row.url + row.detailId : '/' + row.url, 
        '9': row.detailId ? '/' + row.url + row.detailId : '/' + row.url, 
        '10': row.detailId ? '/' + row.url + row.detailId : '/' + row.url, 
        '11': '/noticeDetail?id=' + row.id,
      }
      
      // 确保urlType存在且在映射中
      if (row.urlType && detailPathMap[row.urlType]) {
        console.log('row.url', detailPathMap[row.urlType]);

        this.isNoticeRevoked(row.id, row.processInstanceId).then((res) => {
          if (res == 'success') {
            // 使用动态路径
            let key
            if (row.type === 3) {
              key = row.detailId
            } else if (row.type === 1) {
              key = row.id
            } else if (row.type === 2) {
              key = row.detailId
            }
            
            const selectedMenuIndex = this.urlArr[key];
            localStorage.setItem('selectedMenuIndex', selectedMenuIndex);
            
            // 确保只处理当前点击的行，防止状态污染
            if (row.urlType == 10) {
              // 只有公告类型才调用公告详情接口
              this.getAnnouncementRead(row.detailId)
            }
            
            // 使用replace而不是push，避免路由历史记录问题
            this.$router.push(detailPathMap[row.urlType]);
          } else {
            console.log('通知被撤回', res);
            this.$router.replace('/noticeDetail');
          }
        })
      } else {
        console.error('无效的urlType或未定义的路径映射:', row.urlType);
      }
      
      this.getRead(row.id)
    },

    //判断通知是否被撤回
    isNoticeRevoked(id, processInstanceId) {
      return this.axios.get('/oa/notice/checkStatus', {
        params: {
          noticeId: id,
          processInstanceId: processInstanceId
        }
      }).then((res) => {
        if (res.code === 0) {
          return res.data;
        } else {
          this.$message.error(res.message);
          return false;
        }
      }).catch((err) => {
        console.log(err);
        this.$message.error('请求失败，请稍后再试');
        return false;
      });
    },
    handleAllRead() {
      this.axios.get('/oa/notice/readAll').then((res) => {
        if (res.code == 0) {
          this.list.forEach(item => item.readStatus = '2');
          // this.readCount.unread = 0;
          // this.readCount.readConfirm = this.totalNum;
          this.getreadCount()
          this.$message.success('全部已读');
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err);
        this.$message.error('请求失败，请稍后再试')
      })
    },
    fetchData(type) {
      if (type == 'reset') {
        this.searchForm = {
          message: '', //消息标题
          type: null, //消息类型 1 审批单 2 公告 3 资产管理 4 考勤 5 系统提示
          status: '',//消息状态 1 未读 2 已读
          startTime: '', //开始时间
          endTime: '', //结束时间
          pageNo: 1,
          pageSize: 10,
        }
        this.page.pageNo = 1
        this.receiveTime = []
      } else {
        if (this.receiveTime.length > 0) {
          this.searchForm.startTime = this.receiveTime[0]
          this.searchForm.endTime = this.receiveTime[1]
        }
      }
      this.searchForm.pageNo = this.page.pageNo
      this.searchForm.pageSize = this.page.pageSize
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.page.pageNo = 1
      }
      this.axios.post('/oa/notice/page', this.searchForm).then(res => {
        if (res.code == 0) {
          this.list = res.data.list || []
          this.totalNum = res.data.totalNum
          this.list.forEach(item => {
            item.status = item.readStatus
          })
          // this.getreadCount()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 消息列表
    getList() {
      this.axios.post('/oa/notice/page', {}).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list
          this.totalNum = res.data.totalNum

          const menuIndexMap = {
            '1': '/officeApproval/approvalMyList',  //我发起的
            '2': '/officeApproval/approvalManageList',  //我处理的
            '3': '/officeApproval/approvalAllList',   //全部审批
            '4': '/officeApproval/approvalCCList',   //抄送给我的
            // 资产管理相关的菜单映射
            '5': '/assetManagement/workPhone/list',
            '6': '/assetManagement/workWechat/list',
            '7': '/assetManagement/workQQ/list',
            '8': '/assetManagement/workEmail/list',
            '9': '/assetManagement/platformAccount/list',
            // 公告相关的菜单映射
            '10': '/home',
          }

          this.urlArr = this.list.reduce((acc, item) => {
            if ((item.type === 3 || item.type === 2) && menuIndexMap[item.urlType]) {
              acc[item.detailId] = menuIndexMap[item.urlType];
            } else if (item.type === 1 && menuIndexMap[item.urlType]) {
              acc[item.id] = menuIndexMap[item.urlType];
            } else {
              acc[item.id] = '/officeApproval/approvalAllList';
            }
            return acc;
          }, {})
          // this.getreadCount()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 消息读取数量统计
    getreadCount() {
      const params =  {
        message: this.searchForm.message, //消息标题
        type: this.searchForm.type, //消息类型 1 审批单 2 公告 3 资产管理 4 考勤 5 系统提示
        status: this.searchForm.status,//消息状态 1 未读 2 已读
        startTime: this.searchForm.startTime, //开始时间
        endTime: this.searchForm.endTime, //结束时间
        pageNo: 1,
        pageSize: 10,
      }
      this.axios.post('/oa/notice/readCount', params).then((res) => {
        if (res.code == 0) {
          // this.readCount = res.data
          this.$store.commit("updateReadCount",  res.data);
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 消息已读确认
    getRead(id) {
      this.axios.post('/oa/notice/read', [id]).then(res => {
        if (res.code == 0) {
          // 已读成功
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 公告消息已读确认
    getAnnouncementRead(detailId) {
      this.$api.announcementLookRead({ id: detailId }).then(res => {
        if (res.code == 0) {
          // 已读成功
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.fetchData()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e
      this.fetchData()
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.content {
  width: 100%;
  margin-top: 16px;
  padding: 0 16px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  min-height: calc(100vh - 118px);
  padding-bottom: 16px;
  border-bottom: 32px solid #F5FAF9;
  border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

  /deep/.container {
    margin-left: 7px;
  }

  /deep/.line {
    position: absolute;
    top: 14px;
    right: 150px;
  }
}

.content-notice-title {
  padding: 36px 0px 0;
  margin: 0 0 24px;
}

.notice-line {
  width: 100%;
  height: 1px;
  background: #EDF2F2;
  margin-bottom: 16px;
}

.content-notice-list {
  .notice-list-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 16px;
    padding: 0 8px;
  }

  .notice-list-title-left {
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #616363;
    margin: 0;

    &::before {
      content: "";
      width: 2px;
      height: 16px;
      background: #00B498;
      margin-right: 8px;
    }

    h4 {
      font-size: 14px;
      margin: 0 8px 0 0;
      color: #303133;
      font-weight: 500;
    }

    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #E23C58;
      margin: 0;
    }
  }

  .notice-list-title-right {
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2F3030;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }

    p {
      margin: 0;
    }

    &:hover {
      color: #00B498;
    }
  }
}

/deep/ .el-range-editor--small.el-input__inner {
  width: 208px;
}

/deep/.el-icon-date {
  position: absolute;
  top: 1px;
  right: 4px;
}
</style>